import clsx from 'clsx';
import { useFirebaseAuthCard } from './useFirebaseAuthCard';
import { AuthCardHeader } from './components/AuthCardHeader';
import { AuthFormAlerts } from './components/AuthFormAlerts';
import { AuthLoginForm } from './components/AuthLoginForm';
import { AuthRegisterForm } from './components/AuthRegisterForm';
import { AuthBottomSection } from './components/AuthBottomSection';
import { AuthContactFooter } from './components/AuthContactFooter';
import type { FirebaseAuthCardProps } from './firebaseAuthTypes';

export function FirebaseAuthCard({ redirectPath }: FirebaseAuthCardProps) {
  const {
    mode,
    authError,
    formDisabled,
    resetMessage,
    showPassword,
    setShowPassword,
    showRegisterPassword,
    setShowRegisterPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    loginForm,
    registerForm,
    tabHint,
    onLogin,
    onRegister,
    onGoogle,
    onForgotPassword,
    switchToLogin,
    switchToRegister,
  } = useFirebaseAuthCard(redirectPath);

  return (
    <div className="flex-1 flex items-center justify-center px-3 sm:px-5">
      <div className="w-full max-w-2xl">
        <div
          className={clsx(
            'rounded-2xl bg-white/95 shadow-xl',
            mode === 'register'
              ? 'space-y-3 p-4 sm:p-5 md:p-6'
              : 'space-y-4 p-5 sm:p-6 md:p-7',
          )}
        >
          <AuthCardHeader subtitle={tabHint} compact={mode === 'register'} />

          <AuthFormAlerts
            authError={authError}
            showPasswordResetHint={mode === 'login' && resetMessage === 'sent'}
          />

          {mode === 'login' ? (
            <AuthLoginForm
              form={loginForm}
              formDisabled={formDisabled}
              resetMessage={resetMessage}
              showPassword={showPassword}
              onTogglePassword={() => setShowPassword((s) => !s)}
              onSubmit={onLogin}
              onForgotPassword={onForgotPassword}
            />
          ) : (
            <AuthRegisterForm
              form={registerForm}
              formDisabled={formDisabled}
              showRegisterPassword={showRegisterPassword}
              showConfirmPassword={showConfirmPassword}
              onToggleRegisterPassword={() => setShowRegisterPassword((s) => !s)}
              onToggleConfirmPassword={() => setShowConfirmPassword((s) => !s)}
              onSubmit={onRegister}
            />
          )}

          <AuthBottomSection
            mode={mode}
            compact={mode === 'register'}
            formDisabled={formDisabled}
            onGoogle={onGoogle}
            onSelectLogin={switchToLogin}
            onSelectRegister={switchToRegister}
          />

          <AuthContactFooter compact={mode === 'register'} />
        </div>
      </div>
    </div>
  );
}
